<template>
  <div class="container">
    <h3>美术团队配置</h3>
    <el-form inline @submit.native.prevent="search(1)">
      <el-form-item label="团队名称"><el-input v-model="name" clearable /></el-form-item>
      <el-form-item><el-button :loading="loading" @click="search(1)">查询</el-button><el-button type="primary" @click="edit()">新增团队</el-button></el-form-item>
    </el-form>
    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
    <el-table :data="rows" v-loading="loading" border>
      <el-table-column prop="name" label="团队名称" />
      <el-table-column label="主管"><template slot-scope="scope">{{ scope.row.manager_usernames.join('、') || '-' }}</template></el-table-column>
      <el-table-column prop="updated_by" label="更新人" />
      <el-table-column label="操作" min-width="180"><template slot-scope="scope"><el-button type="primary" @click="edit(scope.row)" size="mini">编辑</el-button><el-button type="danger" @click="remove(scope.row)" size="mini">删除</el-button></template></el-table-column>
    </el-table>
    <el-pagination :current-page.sync="page" :page-size="10" :total="total" layout="total, prev, pager, next" @current-change="search" />
    <el-dialog :title="form.id ? '编辑团队' : '新增团队'" :visible.sync="dialog" :close-on-click-modal="false" width="min(560px, 95%)">
      <el-alert v-if="directoryError" :title="directoryError" type="error" :closable="false" />
      <el-button v-if="directoryError" type="text" @click="loadManagers">重新加载主管</el-button>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="团队名称" prop="name"><el-input v-model.trim="form.name" maxlength="64" show-word-limit /></el-form-item>
        <el-form-item label="主管"><el-select v-model="form.manager_usernames" multiple filterable :disabled="!!directoryError || directoryLoading" :loading="directoryLoading"><el-option v-for="manager in managers" :key="manager.username" :label="manager.username" :value="manager.username" /></el-select></el-form-item>
      </el-form>
      <span slot="footer"><el-button :disabled="saving" @click="dialog = false">取消</el-button><el-button type="primary" :loading="saving" :disabled="!!directoryError || directoryLoading" @click="save">保存</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { production_list, production_create, production_update, production_delete, production_options } from '@/api/getData';
import { productionError } from '@/utils/production';
export default {
  name: 'config_art_team',
  data: () => ({ name: '', rows: [], total: 0, page: 1, loading: false, saving: false, error: '', dialog: false, form: { manager_usernames: [] }, managers: [], directoryError: '', directoryLoading: false, rules: { name: [{ required: true, whitespace: true, message: '请输入团队名称', trigger: 'blur' }] } }),
  created() { this.search(); },
  methods: {
    async search(page = this.page) {
      this.page = page; this.loading = true; this.error = '';
      try { const data = await production_list('art_team', { name: this.name, limit: 10, offset: (page - 1) * 10 }); this.rows = data.results; this.total = data.count; }
      catch (error) { this.error = productionError(error); }
      finally { this.loading = false; }
    },
    async loadManagers() {
      this.directoryLoading = true; this.directoryError = '';
      try { this.managers = await production_options('users', { role: 6 }); }
      catch (error) { this.directoryError = productionError(error); }
      finally { this.directoryLoading = false; }
    },
    edit(row) {
      this.form = row ? { id: row.id, name: row.name, manager_usernames: [...row.manager_usernames] } : { name: '', manager_usernames: [] };
      this.dialog = true;
      this.$nextTick(() => this.$refs.form.clearValidate());
      this.loadManagers();
    },
    async save() {
      if (!await this.$refs.form.validate().catch(() => false)) return;
      this.saving = true;
      try { const data = { name: this.form.name, manager_usernames: [...this.form.manager_usernames] }; if (this.form.id) await production_update('art_team', this.form.id, data); else await production_create('art_team', data); this.dialog = false; await this.search(); }
      catch (error) { this.$message.error(productionError(error)); }
      finally { this.saving = false; }
    },
    async remove(row) {
      try { await this.$confirm(`删除团队“${row.name}”并解绑主管？`, '确认删除'); await production_delete('art_team', row.id); await this.search(); }
      catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(productionError(error)); }
    }
  }
};
</script>

<style scoped>
h3 { margin-bottom: 20px; }
.el-pagination { margin-top: 20px; text-align: right; }
.el-alert { margin-bottom: 12px; }
.el-select { width: 100%; }
</style>
